import type { AppState } from '../domain/models';

interface WorldReaction {
  id: string;
  title: string;
  copy: string;
  icon: string;
  active: boolean;
}

export function deriveWorldReactions(state: AppState): WorldReaction[] {
  const today = new Date().toISOString().slice(0, 10);
  const hasRecord = state.records.some((record) => record.occurredAt.slice(0, 10) === today);
  const missionDone = state.missions.some((mission) => ['submitted', 'approved'].includes(mission.status));
  const quizDone = state.quizAttempts.some((attempt) => attempt.completedAt.slice(0, 10) === today);
  const familyConnected = state.messages.length > 0;
  return [
    { id: 'snowball', title: '스노우볼 성장', copy: hasRecord ? '오늘의 기록만큼 눈덩이가 커졌어요.' : '돈을 기록하면 눈덩이가 커져요.', icon: '/assets/ui-icons/mrm_ui_01a_record_v01.png', active: hasRecord },
    { id: 'market', title: '마켓 별빛', copy: missionDone ? '현명한 선택으로 마켓 간판에 별이 켜졌어요.' : '미션을 끝내면 마켓 별빛이 켜져요.', icon: '/assets/ui-icons/mrm_ui_12a_mission_v01.png', active: missionDone },
    { id: 'aurora', title: '오로라 신호', copy: quizDone ? '경제 퀴즈를 풀어 관측소 오로라가 밝아졌어요.' : '퀴즈를 풀면 오로라가 밝아져요.', icon: '/assets/ui-icons/mrm_ui_12d_concept_v01.png', active: quizDone },
    { id: 'fridge', title: '냥장고 불빛', copy: familyConnected ? '가족의 응원이 냥장고 집에 따뜻하게 보관됐어요.' : '가족 대화를 나누면 집에 불이 켜져요.', icon: '/assets/ui-icons/mrm_ui_08_familytalk_v01.png', active: familyConnected },
  ];
}

export function WorldReactionStrip({ state, compact = false }: { state: AppState; compact?: boolean }) {
  const reactions = deriveWorldReactions(state);
  const active = reactions.filter((item) => item.active).length;
  return <section className={`world-reaction-strip ${compact ? 'compact' : ''}`} aria-label="나의 선택으로 달라진 스노우 월드">
    <header><div><small>MY WORLD REACTION</small><strong>내 선택으로 월드가 {active}곳 달라졌어요</strong></div><span>{active}/4</span></header>
    <div>{reactions.map((reaction) => <article key={reaction.id} className={reaction.active ? 'active' : ''}><img src={reaction.icon} alt=""/><span><strong>{reaction.title}</strong><small>{reaction.copy}</small></span><b>{reaction.active ? '빛남' : '대기'}</b></article>)}</div>
  </section>;
}
